import { type ReactNode, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useTranslateContent = () => {
  const { t } = useTranslation();

  return useCallback(
    (content?: ReactNode): ReactNode => (typeof content === 'string' ? t(content) : (content ?? null)),
    [t],
  );
};
